import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import jsPDF from 'jspdf';
import { API_URL } from '../../api';
import axios from 'axios';
import SignatureCanvas from 'react-signature-canvas';






// Ordem dos processos (inclui Pré-Impressão!)
const processosOrdem = [
  'Guilhotina',
  'Pré-Impressão',
  'Impressão',
  'Laminadora',
  'Serigrafia',
  'Empastadeira',
  'Acopladeira',
  'Onduladeira',
  'Corte e Vinco',
  'Hotstamping',
  'Destaques',
  'Fechadora',
  'Fresa',
  'Caixa Rígida',
  'Bancada Caixa Rígida',
  'Bancada Clientes Diversos',
];



// Campos por processo
const camposPorProcesso = {
'Guilhotina': [
  { nome: 'houveDificuldades', label: 'Houve Dificuldades no Corte?', tipo: 'radio', opcoes: ['Sim', 'Não'] }
],


  'Pré-Impressão': [
    { nome: 'responsavel', label: 'Nome do Responsável', tipo: 'text' }
  ],
  'Impressão': [],
  'Serigrafia': [],
  'Laminadora': [
    { nome: 'gestorProcesso', label: 'Gestor do Processo', tipo: 'text' },
    { nome: 'dataProcesso', label: 'Data do Processo', tipo: 'date' },
    { nome: 'velocidadeProducao', label: 'Velocidade de Produção', tipo: 'text' },
    { nome: 'tipoLaminacao', label: 'Tipo de laminação', tipo: 'text' },
    { nome: 'larguraBobina', label: 'Largura da Bobina', tipo: 'text' },
    { nome: 'horasAcerto', label: 'Quantas horas de acerto?', tipo: 'text' }
  ],
'Acopladeira': [
  { nome: 'gestorProcesso', label: 'Gestor do Processo', tipo: 'text' },
  { nome: 'maquinaSBL', label: 'SBL', tipo: 'checkbox' },
  { nome: 'maquinaSPIRE', label: 'SPIRE', tipo: 'checkbox' },    { nome: 'dataProcesso', label: 'Data do Processo', tipo: 'date' },
  { nome: 'velocidadeProducao', label: 'Velocidade de Produção', tipo: 'text' },
  { nome: 'tipoAcoplamento', label: 'Tipo de acoplamento', tipo: 'select', opcoes: ['Simples (3 camadas)', 'Duplo (4 camadas)', 'Cartão + cartão (2 camadas)'] },
  { nome: 'horasAcerto', label: 'Quantas horas de acerto?', tipo: 'text' },
  { nome: 'outro', label: 'Outro', tipo: 'text' }
],

  'Onduladeira': [
    { nome: 'gestorProcesso', label: 'Gestor do Processo', tipo: 'text' },
    { nome: 'dataProcesso', label: 'Data do Processo', tipo: 'date' },
    { nome: 'velocidadeProducao', label: 'Velocidade de Produção', tipo: 'text' },
    { nome: 'maquinaUtilizada', label: 'Máquina utilizada', tipo: 'text' },
    { nome: 'mudancaMateriaPrima', label: 'Houve mudança de matéria prima?', tipo: 'select', opcoes: ['Sim', 'Não'] },
    { nome: 'qualMateriaPrima', label: 'Qual?', tipo: 'text' },
    { nome: 'novaMPAprovada', label: 'A nova MP está aprovada?', tipo: 'select', opcoes: ['Sim', 'Não'] },
    { nome: 'motivo', label: 'Motivo', tipo: 'text' },
    { nome: 'horasAcerto', label: 'Quantas horas de acerto?', tipo: 'text' },
    { nome: 'larguraBobina', label: 'Largura da Bobina', tipo: 'text' },
    { nome: 'tipoMicro', label: 'Tipo de micro', tipo: 'select', opcoes: ['Onda B', 'Onda E', 'Onda F'] },
    { nome: 'marcaBobina', label: 'Marca da Bobina', tipo: 'text' }
  ],
'Corte e Vinco': [
  { nome: 'gestorProcesso', label: 'Gestor do Processo', tipo: 'text' },
  { nome: 'maquinaBobst', label: 'BOBST', tipo: 'checkbox' },
  { nome: 'maquinaSBL', label: 'SBL', tipo: 'checkbox' },
  { nome: 'maquinaHercules', label: 'HÉRCULES', tipo: 'checkbox' },
  { nome: 'maquinaBocaSapo', label: 'BOCA DE SAPO', tipo: 'checkbox' },
  { nome: 'dataProcesso', label: 'Data do Processo', tipo: 'date' },
  { nome: 'velocidadeProducao', label: 'Velocidade de Produção', tipo: 'text' },
  { nome: 'pertinaxVinco', label: 'Pertinax Vinco', tipo: 'text' },
  { nome: 'altura', label: 'Altura', tipo: 'text' },
  { nome: 'abertura', label: 'Abertura', tipo: 'text' },
  { nome: 'canaleta', label: 'Canaleta', tipo: 'text' },
  { nome: 'mudancaMateriaPrima', label: 'Houve mudança de matéria prima?', tipo: 'select', opcoes: ['Sim', 'Não'] },
  { nome: 'qualMateriaPrima', label: 'Qual?', tipo: 'text' },
  { nome: 'novaMPAprovada', label: 'A nova MP está aprovada?', tipo: 'select', opcoes: ['Sim', 'Não'] },
  { nome: 'motivo', label: 'Motivo', tipo: 'text' },
  { nome: 'horasAcerto', label: 'Quantas horas de acerto?', tipo: 'text' }
],

  'Hotstamping': [
    { nome: 'gestorProcesso', label: 'Gestor do Processo', tipo: 'text' },
    { nome: 'dataProcesso', label: 'Data do Processo', tipo: 'date' },
    { nome: 'velocidadeProducao', label: 'Velocidade de Produção', tipo: 'text' },
    { nome: 'tipoHotstamping', label: 'Tipo de hotstamping', tipo: 'text' },
    { nome: 'larguraBobina', label: 'Largura da bobina', tipo: 'text' },
    { nome: 'horasAcerto', label: 'Quantas horas de acerto?', tipo: 'text' }
  ],
  'Destaques': [
    { nome: 'responsavel', label: 'Responsável', tipo: 'text' }
  ],
  'Fechadora': [
    { nome: 'gestorProcesso', label: 'Gestor do Processo', tipo: 'text' },
    { nome: 'dataProcesso', label: 'Data do Processo', tipo: 'date' },
    { nome: 'velocidadeProducao', label: 'Velocidade de Produção', tipo: 'text' },
    { nome: 'maquinaUtilizada', label: 'Máquina utilizada', tipo: 'text' },
    { nome: 'caixaColetiva', label: 'Caixa coletiva', tipo: 'text' },
    { nome: 'quantidadeCaixa', label: 'Quantidade na caixa', tipo: 'text' },
    { nome: 'paletizacao', label: 'Paletização', tipo: 'text' }
  ],
'Fresa': [
  { nome: 'gestorProcesso', label: 'Gestor do Processo', tipo: 'text' },
  { nome: 'dataProcesso', label: 'Data do Processo', tipo: 'date' },
  { nome: 'velocidadeProducao', label: 'Velocidade de Produção', tipo: 'text' },
  { nome: 'ferramentaUtilizada', label: 'Qual ferramenta utilizada', tipo: 'text' },
  { nome: 'anguloAbertoFechado', label: 'Ângulo Aberto/Fechado', tipo: 'select', opcoes: ['Aberto', 'Fechado'] },
  { nome: 'horasAcerto', label: 'Quantas horas de acerto?', tipo: 'text' },
  { nome: 'espessuraHorlly', label: 'Espessura Encontrada do Horlly', tipo: 'text' },
  {
    nome: 'dimensionaisFundo',
    label: 'Dimensionais Encontrados FUNDO',
    tipo: 'text',
    placeholder: 'Comprimento x Largura x Altura'
  },
  {
    nome: 'dimensionaisTampa',
    label: 'Dimensionais Encontrados TAMPA',
    tipo: 'text',
    placeholder: 'Comprimento x Largura x Altura'
  }
],


  'Bancada Caixa Rígida': [
    { nome: 'gestorProcesso', label: 'Gestor do Processo', tipo: 'text' },
    { nome: 'dataProcesso', label: 'Data do Processo', tipo: 'date' },
    { nome: 'velocidadeProducao', label: 'Velocidade de Produção', tipo: 'text' },
    { nome: 'quantasPessoas', label: 'Quantas pessoas necessárias', tipo: 'text' },
    { nome: 'horasAcerto', label: 'Quantas horas de acerto?', tipo: 'text' },
    { nome: 'caixaColetiva', label: 'Caixa coletiva', tipo: 'text' },
    { nome: 'quantidadeCaixa', label: 'Quantidade na caixa', tipo: 'text' },
    { nome: 'paletizacao', label: 'Paletização', tipo: 'text' }
  ],
  'Bancada Clientes Diversos': [
    { nome: 'gestorProcesso', label: 'Gestor do Processo', tipo: 'text' },
    { nome: 'dataProcesso', label: 'Data do Processo', tipo: 'date' },
    { nome: 'velocidadeProducao', label: 'Velocidade de Produção', tipo: 'text' },
    { nome: 'quantasPessoas', label: 'Quantas pessoas necessárias', tipo: 'text' },
    { nome: 'horasAcerto', label: 'Quantas horas de acerto?', tipo: 'text' },
    { nome: 'caixaColetiva', label: 'Caixa coletiva', tipo: 'text' },
    { nome: 'quantidadeCaixa', label: 'Quantidade na caixa', tipo: 'text' },
    { nome: 'paletizacao', label: 'Paletização', tipo: 'text' }
  ],
  'Caixa Rígida': [
    { nome: 'gestorProcesso', label: 'Gestor do Processo', tipo: 'text' },
    { nome: 'dataProcesso', label: 'Data do Processo', tipo: 'date' },
    { nome: 'velocidadeProducao', label: 'Velocidade de Produção', tipo: 'text' },
    { nome: 'quantasPessoasMaquina', label: 'Quantas pessoas em máquina', tipo: 'text' },
    { nome: 'quantasPessoasRevisao', label: 'Quantas pessoas para revisão', tipo: 'text' },
    { nome: 'horasAcerto', label: 'Quantas horas de acerto?', tipo: 'text' },
    { nome: 'caixaColetiva', label: 'Caixa coletiva', tipo: 'text' },
    { nome: 'quantidadeCaixa', label: 'Quantidade na caixa', tipo: 'text' },
    { nome: 'paletizacao', label: 'Paletização', tipo: 'text' }
  ],
};



const getCampos = processo => camposPorProcesso[processo] || [];


const ProcessoForm = ({
  onSalvar,
  dadosIniciais,
  usuario,
  somenteLeitura,
  processosIniciais,
  anpSelecionada, 
  handleAbrirAcoes,
  setMostrarResumoAcoes,
  setShowForm,
  resumoAcoes = [],
}) => {
  console.log('🔎 handleAbrirAcoes recebido:', handleAbrirAcoes);


const [modalAssinatura, setModalAssinatura] = useState(null); // 'gestor' ou 'novos'
const [refAssinatura, setRefAssinatura] = useState(null);


const navegarParaAcoes = (nomeDoProcesso) => {
  window.open(`/acoes-anp/${nomeDoProcesso.toLowerCase().replace(/\s+/g, '-').normalize('NFD').replace(/[\u0300-\u036f]/g, '')}`, '_blank');
};



const [modalVisualizarAcoes, setModalVisualizarAcoes] = useState(null);




const normalizeNome = (str) =>
  str.normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s|-/g, "_")
    .toLowerCase();



  // Estado para tipo de usuário
  const [tipoUsuario, setTipoUsuario] = useState(usuario?.tipo || '');
  

  // Estado para controle do modal de imagem
  const [imagemModalAberto, setImagemModalAberto] = useState(null); // { url, nome }
  

  // Permissões
  const [processosPermitidos, setProcessosPermitidos] = useState([]);
  const [formulariosPermitidos, setFormulariosPermitidos] = useState([]);

  // Estado principal de processos
  const [processos, setProcessos] = useState([]);
  const [dados, setDados] = useState({});
  const [feedback, setFeedback] = useState('');

  // Estado dos modais
  const [modalAberto, setModalAberto] = useState(null);
  const [modalVerAberto, setModalVerAberto] = useState(null);


    
useEffect(() => {

  console.log('🧪 handleAbrirAcoes:', handleAbrirAcoes);
  console.log('🧩 dadosIniciais recebidos:', dadosIniciais);
  console.log('📌 processosPermitidos:', processosPermitidos);
  console.log('📌 anpSelecionada?.id:', anpSelecionada?.id);

  if (!dadosIniciais || !anpSelecionada?.id) return;

  const todosProcessos = Object.keys(dadosIniciais || {});
  const processosFiltrados = processosPermitidos.length > 0
    ? todosProcessos.filter(p => processosPermitidos.includes(p))
    : todosProcessos;

  const ordenados = processosFiltrados.sort((a, b) => processosOrdem.indexOf(a) - processosOrdem.indexOf(b));

  setProcessos(ordenados);
  setDados(prev => ({ ...prev, ...dadosIniciais }));
}, [anpSelecionada?.id, dadosIniciais, processosPermitidos]);



 


   // ------------------ PERMISSÕES DE USUARIOS DE PROCESSOS ------------------ //
  
   useEffect(() => {
  if (!usuario || !usuario.tipo) {
    console.log('Usuário não definido ou tipo ausente');
    setProcessosPermitidos([]);
    setFormulariosPermitidos([]);
    return;
  }

  let tipo = usuario.tipo;

// Normaliza para array sempre
if (typeof tipo === 'string') {
  tipo = tipo.split(',').map(t => t.trim().toLowerCase());
} else if (Array.isArray(tipo)) {
  tipo = tipo.map(t => t.trim().toLowerCase());
} else {
  tipo = [];
}

setTipoUsuario(tipo);

// Admin, Projetos, Qualidade têm acesso total
if (tipo.some(t => ['admin', 'projetos', 'qualidade'].includes(t))) {
  setProcessosPermitidos(processosOrdem);
  setFormulariosPermitidos(processosOrdem);
  return;
}


if (tipo.includes('comercial')) {
  console.log('Usuário comercial: somente leitura de todos os processos');
  setProcessosPermitidos(processosOrdem);
  setFormulariosPermitidos([]);
  return;
}

const permissoes = {
  guilhotina: 'Guilhotina',
  pre_impressao: 'Pré-Impressão',
  impressao: 'Impressão',
  serigrafia: 'Serigrafia',
  laminadora: 'Laminadora',
  empastadeira: 'Empastadeira',
  acopladora: 'Acopladora',
  onduladeira: 'Onduladeira',
  corte_vinco: 'Corte e Vinco',
  hotstamping: 'Hotstamping',
  destaques: 'Destaques',
  fechadora: 'Fechadora',
  fresa: 'Fresa',
  caixa_rigida: 'Caixa Rígida',
  bancada_rigida: 'Bancada Caixa Rígida',
  bancada_diversos: 'Bancada Clientes Diversos'
};

const permitidos = tipo
  .map(t => permissoes[t])
  .filter(Boolean);

if (permitidos.length > 0) {
  setProcessosPermitidos(permitidos);
  setFormulariosPermitidos(permitidos);
} else {
  console.log('Tipo de usuário não reconhecido');
  setProcessosPermitidos([]);
  setFormulariosPermitidos([]);
}


}, [usuario]);

  
  
  

  // ------------------ FIM DA LISTA PERMISSÕES DE USUARIOS DE PROCESSOS ------------------ //
  


  const processosDisponiveis = processosOrdem.filter(p => !processos.includes(p));

  const handleAddProcesso = (processo) => {
    const novaLista = Array.from(new Set([...processos, processo]))
      .sort((a, b) => processosOrdem.indexOf(a) - processosOrdem.indexOf(b));
    setProcessos(novaLista);
  };

  const handleRemoverProcesso = async (processo) => {
    setProcessos(processos.filter(p => p !== processo));
    setDados(prev => {
      const novo = { ...prev };
      delete novo[processo];
      return novo;
    });



 
    // Enviar requisição para deletar também do backend (cadastrosANP.json)
    try {
      await fetch(`${API_URL}/anp/deletar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ processo })
      });
    } catch (error) {
      console.error('Erro ao deletar do backend:', error);
    }
  };
  

const handleChange = (processo, nomeCampo, valor) => {
  console.log(`🔄 Alteração: processo=${processo}, campo=${nomeCampo}, valor=${valor}`);

  setDados(prev => {
    const processoAtual = prev[processo] || {};
    const valorAtual = processoAtual[nomeCampo];

    // Se o valor não mudou, não faz nada
    if (valorAtual === valor) return prev;

    return {
      ...prev,
      [processo]: {
        ...processoAtual,
        [nomeCampo]: valor,
        alteradoPor: usuario?.nome || processoAtual.alteradoPor || ''
      }
    };
  });
};


  const handleParecerChange = (processo, qual, valor) => {
    setDados(prev => ({
      ...prev,
      [processo]: {
        ...prev[processo],
        [`parecer_${qual}`]: valor
      }
    }));
  };

const handleUploadAnexo = async (e, nomeDoProcesso, campo) => {
  const file = e.target.files[0];
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await axios.post(`${API_URL}/anp/upload-anexo`, formData, {
      headers: {
        'x-processo': nomeDoProcesso,
        'x-anpid': anpSelecionada?.id || ''
      }
    });

   if (response.data.sucesso) {
  const fileUrl = response.data.fileUrl;

  // ✅ Atualiza o estado com o nome real salvo no servidor
  setDados(prev => ({
    ...prev,
    [nomeDoProcesso]: {
      ...prev[nomeDoProcesso],
      anexos: {
        ...(prev[nomeDoProcesso]?.anexos || {}),
        [campo]: {
          nome: response.data.filename,
          url: fileUrl
        }
      }
    }
  }));

      alert('Arquivo enviado com sucesso!');
    } else {
      alert(`Erro ao enviar o arquivo "${file.name}".`);
    }
  } catch (error) {
    console.error("Erro geral no upload:", error);
    alert(`Erro ao enviar o arquivo "${file.name}".`);
  }
};




  
  
  const handleExcluirAnexo = async (processo, campo, filename) => {
    try {
      await fetch(`${API_URL}/anp/deletar-anexo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ processo: normalizeNome(processo), filename })
      });
  
      setDados(prev => {
        const novos = { ...prev };
        if (novos[processo]?.anexos) {
          delete novos[processo].anexos[campo];
        }
        return novos;
      });
    } catch (error) {
      console.error('Erro ao excluir anexo:', error);
    }
  };
  
  const handleExcluirTodosAnexos = async (processo) => {
    try {
      await fetch(`${API_URL}/anp/deletar-todos-anexos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ processo })
      });
  
      setDados(prev => {
        const novos = { ...prev };
        if (novos[processo]) {
          delete novos[processo].anexos;
        }
        return novos;
      });
    } catch (error) {
      console.error('Erro ao excluir todos os anexos:', error);
    }
  };
  

 


  //BOTÃO SALVAR
const handleSalvar = async (e) => {
  e.preventDefault();

  const dadosFiltrados = Object.keys(dados).reduce((acc, processo) => {
    if (processosPermitidos.includes(processo)) {
      acc[processo] = dados[processo];
    }
    return acc;
  }, {});
  



  if (onSalvar) {
  // Marca os processos com ações preenchidas
  Object.keys(dadosFiltrados).forEach(processo => {
    const d = dadosFiltrados[processo];
    if (
      d?.situacao?.trim() ||
      d?.causaRaiz?.trim() ||
      d?.solucoesPropostas?.trim() ||
      d?.responsavel?.trim() ||
      d?.prazo?.trim() ||
      d?.status?.trim() ||
      d?.dataOcorrencia?.trim() ||
      d?.avaliacao?.trim()
    ) {
      d.acoesPreenchidas = true;
    }
  });
console.log("✅ dadosFiltrados que serão enviados para o back-end:", dadosFiltrados);

  const resultado = await onSalvar(dadosFiltrados);

  if (resultado?.sucesso) {
    setFeedback('Salvo com sucesso!');
    setTimeout(() => setFeedback(''), 1200);
  }


}};

    
  const handleGerarRelatorio = (e) => {
    e.preventDefault();
    const doc = new jsPDF('p', 'pt', 'a4');
    let y = 36;
  
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text('Relatório de Acompanhamento de Novo Produto', 40, y);
    y += 32;
  
    processos.forEach((processo) => {
      doc.setFontSize(14);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(36, 89, 185);
      doc.text(processo, 40, y);
      y += 24;
      doc.setTextColor(0, 0, 0);
  
      getCampos(processo).forEach((campo) => {
        const valor = dados[processo]?.[campo.nome] || '';
        let valorTexto = valor;
        if (campo.tipo === 'date' && valor)
          valorTexto = new Date(valor).toLocaleDateString();
        if (valorTexto) {
          doc.setFontSize(12);
          doc.text(`${campo.label}:`, 40, y);
          doc.text(valorTexto, 200, y);
          y += 18;
        }
        if (y > 780) { doc.addPage(); y = 36; }
      });
  
      // Adicionando Pareceres
      ['setor', 'novos'].forEach((qual, i) => {
        const titulo = qual === 'setor' ? 'Parecer do Setor' : 'Parecer dos Novos Projetos';
        const val = dados[processo]?.[`parecer_${qual}`] || '';
        doc.setFontSize(12);
        doc.setTextColor(80, 80, 80);
        doc.text(`${titulo}:`, 40, y);
        y += 14;
        if (val) {
          const split = doc.splitTextToSize(val, 470);
          doc.text(split, 60, y);
          y += split.length * 13;
        } else {
          y += 13;
        }
        doc.setTextColor(0, 0, 0);
        if (y > 780) { doc.addPage(); y = 36; }
      });
  
      // Aprovações e Assinaturas
      doc.setFontSize(12);
      doc.text('Aprovação Gestor:', 40, y);
      doc.text((dados[processo]?.aprovGestor === 'sim') ? 'SIM' : (dados[processo]?.aprovGestor === 'nao') ? 'NÃO' : '-', 150, y);
      doc.text('Assinatura:', 200, y);
      if (dados[processo]?.assinGestor) doc.text(dados[processo]?.assinGestor, 270, y);
  
      doc.text('Aprovação Novos Projetos:', 350, y);
      doc.text((dados[processo]?.aprovNovos === 'sim') ? 'SIM' : (dados[processo]?.aprovNovos === 'nao') ? 'NÃO' : '-', 510, y);
      doc.text('Assinatura:', 550, y);
      if (dados[processo]?.assinNovos) doc.text(dados[processo]?.assinNovos, 630, y);
  
      y += 24;
      if (y > 780) { doc.addPage(); y = 36; }
    });
  
    doc.save('relatorio-acompanhamento.pdf');
  };
  
 

  // -------------------- FORMULARIO PADRÃO DO APLICATIVO -------------------- //
return (
  <form>
    {/* Título antes dos chips */}
    <div style={{ textAlign: 'center', marginTop: 16, fontWeight: 'bold', fontSize: 20, color: '#333' }}>
      Selecione os Processos pertinentes a este Projeto
    </div>




<div style={{ textAlign: 'center', marginTop: 24 }}>
  <button
    type="button"
    onClick={() => {
      console.log('🟢 CLICOU EM "Visualizar Ações Pós Produção"');
      console.log('setMostrarResumoAcoes:', setMostrarResumoAcoes);
      console.log('setShowForm:', setShowForm);

      if (typeof setMostrarResumoAcoes === 'function') {
        setMostrarResumoAcoes(true);
      }
      if (typeof setShowForm === 'function') {
        setShowForm(false);
      }
    }}
    style={{
      backgroundColor: '#6a1b9a',
      color: '#fff',
      fontWeight: 'bold',
      padding: '10px 20px',
      borderRadius: 8,
      border: 'none',
      cursor: 'pointer',
      fontSize: 16
    }}
  >
    Visualizar Ações Pós Produção
  </button>
</div>





    <div style={{
      display: 'flex', flexWrap: 'wrap', gap: 16, margin: '20px 0 0 0',
      justifyContent: 'center'
    }}>
      <AnimatePresence>
      {!somenteLeitura &&
  processosDisponiveis.filter(p => processosPermitidos.includes(p)).map(p => (
    <motion.button
      key={p}
      type="button"
      onClick={() => handleAddProcesso(p)}

            whileTap={{ scale: 0.94 }}
            whileHover={{ backgroundColor: "#298cfd", color: "#fff" }}
            initial={{ scale: 0.7, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.7, opacity: 0 }}
            style={{
              background: '#e4f0fd',
              border: 'none',
              borderRadius: 16,
              padding: '12px 20px',
              fontSize: 16,
              fontWeight: 'bold',
              color: '#126cc5',
              cursor: 'pointer',
              boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
              transition: 'background .2s, color .2s'
            }}
          >
            {p}
          </motion.button>
        ))}
      </AnimatePresence>


    </div>
  
    {modalAberto && (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 10
    }}>
      <div style={{ background: '#fff', padding: 24, borderRadius: 8, minWidth: 320 }}>
        <h3>Anexar Imagens - {modalAberto}</h3>
{[1, 2, 3, 4, 5, 6].map(i => {
  const campo = `anexo${i}`;
  const anexo = dados[modalAberto]?.anexos?.[campo];
  return (
    <div key={i} style={{ marginBottom: 12 }}>
      
      
      <label>Anexo {i}: </label>

<input
  type="file"
  accept="image/*,video/*"
  onChange={(e) => handleUploadAnexo(e, modalAberto, campo)}
/>

<input
  type="text"
  placeholder="Legenda (ex: Visão frontal do produto)"
  value={dados[modalAberto]?.anexos?.[campo]?.legenda || ''}
  onChange={(e) =>
    setDados(prev => ({
      ...prev,
      [modalAberto]: {
        ...prev[modalAberto],
        anexos: {
          ...(prev[modalAberto]?.anexos || {}),
          [campo]: {
            ...(prev[modalAberto]?.anexos?.[campo] || {}),
            legenda: e.target.value
          }
        }
      }
    }))
  }
  style={{
    marginTop: 6,
    width: '100%',
    fontSize: 14,
    padding: '4px 6px',
    borderRadius: 4,
    border: '1px solid #aaa'
  }}
/>

{anexo && (
  <div style={{ marginTop: 6 }}>
    <a
      href={`https://projetos.impram.com.br/Anexos/${normalizeNome(modalAberto)}/${anexo.nome}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      🔗 Ver Anexo
    </a>

    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (window.confirm('Tem certeza que deseja excluir esta imagem?')) {
          handleExcluirAnexo(modalAberto, campo, anexo.nome);
        }
      }}
      style={{
        float: 'right',
        color: 'white',
        backgroundColor: '#c00',
        border: 'none',
        borderRadius: 6,
        padding: '4px 10px',
        cursor: 'pointer',
        fontWeight: 'bold'
      }}
    >
      Excluir
    </button>
  </div>
)}





    </div>
  );
})}


        <button onClick={() => setModalAberto(null)}>Fechar</button>
      </div>
    </div>
  )}



   {/* Campos dos processos já adicionados */}
   {processos.map(processo => (
          <motion.fieldset
            key={processo}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 30 }}
            transition={{ duration: 0.22 }}
            style={{
              margin: '3rem auto',
              padding: '1.5rem',
              border: '1px solid #ccc',
              borderRadius: 8,
              position: 'relative',
              backgroundColor: '#f9f9f9',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              maxWidth: 1080,           // ✅ limite para manter todos iguais
              width: '100%',           // ✅ força responsividade
              boxSizing: 'border-box'  // ✅ garante consistência em celulares
            }}

          >
<div style={{ position: 'relative' }}>
  <legend style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 18, color: '#444', flexWrap: 'wrap' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <b>{processo}</b>

      <button
        type="button"
        onClick={() => setModalAberto(processo)}
        style={{ backgroundColor: '#f0f0f0', padding: '4px 10px', borderRadius: 6, fontSize: 13 }}
      >
        📎 Anexar Imagens
      </button>

      {!somenteLeitura && (
        <motion.button
          type="button"
          onClick={() => handleRemoverProcesso(processo)}
          style={{
            border: 'none',
            background: '#f7bfc4',
            borderRadius: '50%',
            width: 28,
            height: 28,
            cursor: 'pointer',
            color: '#b21a1a',
            fontWeight: 'bold',
            fontSize: 17,
            textAlign: 'center',
            boxShadow: '0 1px 2px #eab',
            transition: 'background .15s, color .15s',
          }}
          title="Remover este processo"
        >
          ×
        </motion.button>
      )}
    </div>
  </legend>

  {dados[processo]?.alteradoPor && (
    <div style={{
      position: 'absolute',
      top: 10,
      right: 12,
      fontSize: 12,
      color: '#666'
    }}>
      Última alteração por: <strong>{dados[processo].alteradoPor}</strong>
    </div>
  )}
</div>






{/* Layout Especial Empastadeira */}
{processo === "Empastadeira" && (
  <div style={{
  display: 'flex',
  gap: 32,
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  background: '#fcfcf7',
  padding: 16,
  borderRadius: 8,
  marginTop: 8,
  marginBottom: 12,
  width: '100%',
  boxSizing: 'border-box'
}}>

    
    {/* Velocidade de Produção */}
    <div style={{ minWidth: 260 }}>
      <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 4 }}>
        Informações da Produção
      </div>


      
      <div style={{ marginBottom: 8 }}>
        <label style={{ fontSize: 14 }}>
          Velocidade de Produção:&nbsp;
        </label>
        <input
          type="text"
          disabled={somenteLeitura}
          style={{ width: 140, fontSize: 15, padding: '4px 8px', borderRadius: 5, border: '1px solid #aaa' }}
          value={dados[processo]?.velocidadeProducao || ''}
          onChange={e => handleChange(processo, 'velocidadeProducao', e.target.value)}
          placeholder="Ex: 1200 P/H"
        />
      </div>
    </div>

  </div>
)}



{/* Layout Especial Impressão */}
{processo === "Impressão" && (
  <>
    {/* Papel + Cores */}
    <div style={{
  display: 'flex',
  gap: 28,
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  background: '#fcfcf7',
  padding: 16,
  borderRadius: 8,
  marginTop: 8,
  marginBottom: 12,
  width: '100%',
  boxSizing: 'border-box'
}}>

      {/* PAPEL */}
      <div style={{ minWidth: 280, maxWidth: 340 }}>



{/* IMPRESSORA */}
<div style={{ marginBottom: 8 }}>
  <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 4 }}>Impressora:</div>
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
    {[
      ['komori1', 'KOMORI 1'],
      ['komori2', 'KOMORI 2 (HUV)'],
      ['komori3', 'KOMORI 3'],
      ].map(([campo, label]) => (
      <label key={campo} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <input
          type="checkbox"
          disabled={somenteLeitura}
          checked={!!dados[processo]?.[campo]}
          onChange={e => handleChange(processo, campo, e.target.checked)}
        /> {label}
      </label>
    ))}
  </div>
</div>



        <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 2 }}>Papel Utilizado</div>
        <div style={{ marginBottom: 4 }}>
          <input
            type="text"
            disabled={somenteLeitura}
            style={{ width: '99%', marginBottom: 5 }}
            placeholder="Descreva o papel utilizado"
            value={dados[processo]?.papelUtilizado || ''}
            onChange={e => handleChange(processo, 'papelUtilizado', e.target.value)}
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 3 }}>
          <span style={{ fontSize: 14 }}>Espessura:&nbsp;</span>
          <input
            type="text"
            disabled={somenteLeitura}
            style={{ width: 60, marginRight: 12 }}
            value={dados[processo]?.espessura || ''}
            onChange={e => handleChange(processo, 'espessura', e.target.value)}
          />
          <span style={{ fontSize: 14 }}>Gramatura:&nbsp;</span>
          <input
            type="text"
            disabled={somenteLeitura}
            style={{ width: 60 }}
            value={dados[processo]?.gramatura || ''}
            onChange={e => handleChange(processo, 'gramatura', e.target.value)}
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 3 }}>
          {[
            ['papelReversao', 'Reversão'],
            ['papelFrente', 'Frente'],
            ['papelFrenteVerso', 'Frente/Verso'],
            ['papelLadoCoating', 'Lado Coating'],
            ['papelLadoUnCoating', 'Lado UnCoating'],
          ].map(([nome, label]) => (
            <label key={nome} style={{ display: 'flex', alignItems: 'center', minWidth: 104, fontSize: 14 }}>
              <input
                type="checkbox"
                disabled={somenteLeitura}
                checked={!!dados[processo]?.[nome]}
                onChange={e => handleChange(processo, nome, e.target.checked)}
                style={{ marginRight: 4 }}
              />{label}
            </label>
          ))}
        </div>
        <div style={{ marginBottom: 2 }}>
          <span>Quantas Entradas de Máquina&nbsp;</span>
          <input
            type="text"
            disabled={somenteLeitura}
            style={{ width: 85 }}
            value={dados[processo]?.quantasEntradasMaquina || ''}
            onChange={e => handleChange(processo, 'quantasEntradasMaquina', e.target.value)}
          />
        </div>
        <div style={{ marginTop: 6 }}>
  <span>Velocidade de Produção&nbsp;</span>
  <input
    type="text"
    disabled={somenteLeitura}
    style={{ width: 140 }}
    value={dados[processo]?.velocidadeProducao || ''}
    onChange={e => handleChange(processo, 'velocidadeProducao', e.target.value)}
    placeholder="Ex: 6500 P/H"
  />
</div>
      </div>

      {/* SEQUÊNCIA DE CORES */}
      <div>
        <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 4 }}>Sequência de Cores:</div>
        {[1, 2, 3, 4, 5, 6].map(idx => (
          <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
            <span style={{ width: 74 }}>{idx} bateria:</span>
            <input
              type="text"
              disabled={somenteLeitura}
              style={{ width: 140, marginRight: 16, fontSize: 15 }}
              value={dados[processo]?.[`bateria${idx}`] || ''}
              onChange={e => handleChange(processo, `bateria${idx}`, e.target.value)}
              placeholder="Cor"
            />
            <span style={{ width: 75 }}>Densidade:</span>
            <input
              type="text"
              disabled={somenteLeitura}
              style={{ width: 120, fontSize: 15 }}
              value={dados[processo]?.[`densidade${idx}`] || ''}
              onChange={e => handleChange(processo, `densidade${idx}`, e.target.value)}
              placeholder="Dens."
            />
          </div>
        ))}
      </div>
    </div>

    {/* Verniz + Cilindro juntos, em linha */}
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '48px', margin: '18px 0 2px 0', alignItems: 'flex-start' }}>
      <div>
        <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 4 }}>Verniz:</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, minWidth: 320 }}>
          {[
            ['vernizTotal', 'Total'],
            ['vernizLocal', 'Local'],
            ['vernizCyrel', 'Cyrel'],
            ['vernizUV', 'UV'],
            ['vernizBaseAguaBrilho', 'Base Água Brilho'],
            ['vernizBlister', 'Blister'],
            ['vernizSoftTouch', 'Soft Touch'],
            ['vernizBaseAguaFosco', 'Base Água Fosco'],
          ].map(([nome, label]) => (
            <label key={nome} style={{ display: 'flex', alignItems: 'center', minWidth: 130 }}>
              <input
                type="checkbox"
                disabled={somenteLeitura}
                checked={!!dados[processo]?.[nome]}
                onChange={e => handleChange(processo, nome, e.target.checked)}
                style={{ marginRight: 4 }}
              /> {label}
            </label>
          ))}
        </div>
      </div>

      <div>
        <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 4 }}>Cilindro:</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, minWidth: 220 }}>
          {[
            ['cilindroDesmoldante', 'Desmoldante'],
            ['cilindroPastaFosco', 'Pasta Fosco'],
            ['cilindroReservaChapa', 'Reserva na chapa'],
            ['cilindroReservaCola', 'Reserva de Cola'],
          ].map(([nome, label]) => (
            <label key={nome} style={{ display: 'flex', alignItems: 'center', minWidth: 110 }}>
              <input
                type="checkbox"
                disabled={somenteLeitura}
                checked={!!dados[processo]?.[nome]}
                onChange={e => handleChange(processo, nome, e.target.checked)}
                style={{ marginRight: 4 }}
              /> {label}
            </label>
          ))}
        </div>
      </div>
    </div>
  </>
)}


{/* Layout Especial Serigrafia */}
{processo === "Serigrafia" && (
  <div style={{
  display: 'flex',
  gap: 26,
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  background: '#fcfcf7',
  padding: 16,
  borderRadius: 8,
  marginTop: 8,
  marginBottom: 12,
  width: '100%',
  boxSizing: 'border-box'
}}>

    {/* Papel */}
    <div style={{ minWidth: 230 }}>
      <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 2 }}>Papel</div>
      <div>
        <span style={{ fontSize: 13 }}>For. do Papel&nbsp;</span>

        
        <input
          type="text"
          disabled={somenteLeitura}
          style={{ width: 110, marginBottom: 4 }}
          value={dados[processo]?.forPapel || ''}
          onChange={e => handleChange(processo, 'forPapel', e.target.value)}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
        {[
          ['serigrafiaFrente', 'Frente'],
          ['serigrafiaFrenteVerso', 'Frente/Verso'],
          ['serigrafiaLadoCoating', 'Lado Coating'],
          ['serigrafiaLadoUnCoating', 'Lado UnCoating'],
        ].map(([nome, label]) => (
          <label key={nome} style={{ display: 'flex', alignItems: 'center', minWidth: 104, fontSize: 14 }}>
            <input
              type="checkbox"
              disabled={somenteLeitura}
              checked={!!dados[processo]?.[nome]}
              onChange={e => handleChange(processo, nome, e.target.checked)}
              style={{ marginRight: 4 }}
            />{label}
          </label>
        ))}
       <span>Quantas Entradas de Máquina&nbsp;</span>
<input
  type="text"
  disabled={somenteLeitura}
  style={{ width: 60 }}
  value={dados[processo]?.serigrafiaEntradasMaquina || ''}
  onChange={e => handleChange(processo, 'serigrafiaEntradasMaquina', e.target.value)}
/>

<div style={{ marginTop: 6 }}>
  <span>Velocidade de Produção&nbsp;</span>
  <input
    type="text"
    disabled={somenteLeitura}
    style={{ width: 140 }}
    value={dados[processo]?.velocidadeProducao || ''}
    onChange={e => handleChange(processo, 'velocidadeProducao', e.target.value)}
    placeholder="Ex: 1500 P/H"
  />
</div>

      </div>
    </div>

    {/* Cores */}
    <div style={{ minWidth: 250 }}>
      <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 2 }}>Cores <span style={{ fontSize: 11 }}>(Especificar)</span></div>
      {[1, 2, 3, 4].map(idx => (
        <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
          <input
            type="text"
            disabled={somenteLeitura}
            style={{ width: 140, fontSize: 15 }}
            value={dados[processo]?.[`cores${idx}`] || ''}
            onChange={e => handleChange(processo, `cores${idx}`, e.target.value)}
            placeholder={`Cor ${idx}`}
          />
        </div>
      ))}
    </div>

    {/* Verniz */}
    <div style={{ minWidth: 160 }}>
      <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 2 }}>Verniz</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <label style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            disabled={somenteLeitura}
            checked={!!dados[processo]?.serigrafiaVernizTotal}
            onChange={e => handleChange(processo, 'serigrafiaVernizTotal', e.target.checked)}
            style={{ marginRight: 4 }}
          /> Total
        </label>
        <label style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            disabled={somenteLeitura}
            checked={!!dados[processo]?.serigrafiaVernizLocal}
            onChange={e => handleChange(processo, 'serigrafiaVernizLocal', e.target.checked)}
            style={{ marginRight: 4 }}
          /> Local
        </label>
        <label style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            disabled={somenteLeitura}
            checked={!!dados[processo]?.serigrafiaBrilhoUV}
            onChange={e => handleChange(processo, 'serigrafiaBrilhoUV', e.target.checked)}
            style={{ marginRight: 4 }}
          /> BRILHO UV
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <label style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              disabled={somenteLeitura}
              checked={!!dados[processo]?.serigrafiaVernizOutro}
              onChange={e => handleChange(processo, 'serigrafiaVernizOutro', e.target.checked)}
              style={{ marginRight: 4 }}
            /> OUTRO
          </label>
          <input
            type="text"
            disabled={somenteLeitura}
            style={{ width: 70, fontSize: 14 }}
            value={dados[processo]?.serigrafiaVernizOutroDesc || ''}
            onChange={e => handleChange(processo, 'serigrafiaVernizOutroDesc', e.target.value)}
            placeholder=""
          />
        </div>
      </div>
    </div>
  </div>
)}


{/* Layout Especial Corte Vinco */}
{processo === "Corte e Vinco" && (
<div style={{
  background: '#fcfcf7',
  padding: 16,
  borderRadius: 8,
  marginBottom: 12,
  marginTop: 8,
  width: '100%',
  boxSizing: 'border-box'
}}>


    {/* Gestor do Processo */}
    <div style={{ marginBottom: 12 }}>
      <label style={{ fontWeight: 500, fontSize: 15 }}>
        Gestor do Processo:&nbsp;
        <input
          type="text"
          disabled={somenteLeitura}
          value={dados[processo]?.gestorProcesso || ''}
          onChange={e => handleChange(processo, 'gestorProcesso', e.target.value)}
          style={{ width: 280, fontSize: 15, padding: '4px 8px', borderRadius: 5, border: '1px solid #aaa' }}
        />
      </label>
    </div>

    {/* Máquinas disponíveis para Corte e Vinco */}
    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 18,
      margin: '12px 0 6px 0',
      alignItems: 'center'
    }}>
      {[
        ['maquinaBobst', 'BOBST'],
        ['maquinaSBL', 'SBL'],
        ['maquinaHercules', 'HÉRCULES'],
        ['maquinaBocaSapo', 'BOCA DE SAPO'],
      ].map(([campo, label]) => (
        <label key={campo} style={{ display: 'flex', alignItems: 'center', fontSize: 14, minWidth: 150 }}>
          <input
            type="checkbox"
            disabled={somenteLeitura}
            checked={!!dados[processo]?.[campo]}
            onChange={e => handleChange(processo, campo, e.target.checked)}
            style={{ marginRight: 6 }}
          />
          {label}
        </label>
      ))}
    </div>

    {/* Linha das perguntas e inputs */}
    <div style={{
      display: 'flex',
      gap: 22,
      alignItems: 'flex-start',
      justifyContent: 'center',
      marginBottom: 0,
      flexWrap: 'wrap'
    }}>

      
      {/* Coluna 1: Pertinax Vinco */}
      <div style={{ background: '#edeef1', borderRadius: 6, padding: 10, minWidth: 220, flex: 1 }}>
        <b style={{ fontSize: 14 }}>Pertinax Vinco</b>
        <div style={{ fontSize: 13, marginTop: 6, display: 'flex', flexDirection: 'column', gap: 6 }}>
          {[
            ['pertinaxAltura', 'Altura:'],
            ['pertinaxAbertura', 'Abertura:'],
            ['pertinaxLaminaMista', 'Abertura lamina mista:'],
            ['pertinaxVincoDuplo', 'Abertura vinco duplo:']
          ].map(([campo, label]) => (
            <div key={campo}>
              <div>{label}</div>
              <input
                type="text"
                disabled={somenteLeitura}
                style={{ width: '95%' }}
                value={dados[processo]?.[campo] || ''}
                onChange={e => handleChange(processo, campo, e.target.value)}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Coluna 2: Canaleta */}
      <div style={{ background: '#edeef1', borderRadius: 6, padding: 10, minWidth: 220, flex: 1 }}>
        <b style={{ fontSize: 14 }}>Canaleta</b>
        <div style={{ fontSize: 13, marginTop: 6, display: 'flex', flexDirection: 'column', gap: 6 }}>
          {[
            ['canaletaAltura', 'Altura:'],
            ['canaletaAbertura', 'Abertura:'],
            ['canaletaLaminaMista', 'Abertura lamina mista:'],
            ['canaletaVincoDuplo', 'Abertura vinco duplo:']
          ].map(([campo, label]) => (
            <div key={campo}>
              <div>{label}</div>
              <input
                type="text"
                disabled={somenteLeitura}
                style={{ width: '95%' }}
                value={dados[processo]?.[campo] || ''}
                onChange={e => handleChange(processo, campo, e.target.value)}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Coluna 3: Velocidade, Pressão e Observação */}
      <div style={{ background: '#edeef1', borderRadius: 6, padding: 10, minWidth: 240, flex: 1 }}>
        <b style={{ fontSize: 14 }}>Velocidade de Produção</b>
        <div style={{ fontSize: 13, marginTop: 6 }}>
          <input
            type="text"
            disabled={somenteLeitura}
            style={{ width: '95%' }}
            value={dados[processo]?.velocidadeProducao || ''}
            onChange={e => handleChange(processo, 'velocidadeProducao', e.target.value)}
            placeholder="Ex: 6500 Fls/PH"
          />
        </div>

        <div style={{ marginTop: 14 }}>
          <b style={{ fontSize: 14 }}>Nível de Pressão do Corte</b>
          <div style={{ fontSize: 13, marginTop: 4 }}>
            <input
              type="text"
              disabled={somenteLeitura}
              style={{ width: '95%' }}
              value={dados[processo]?.nivelPressaoCorte || ''}
              onChange={e => handleChange(processo, 'nivelPressaoCorte', e.target.value)}
              placeholder="Ex: 23,5"
            />
          </div>
        </div>

        <div style={{
          marginTop: 18,
          color: '#c00',
          fontSize: 13,
          fontWeight: 500,
          background: '#fff0f0',
          padding: 8,
          borderRadius: 4
        }}>
          obs.: Caso tenha alteração de Pertinax,<br />
          ou retirar pertinax e colocar canaleta,<br />
          informar o motivo e onde foi aplicado
        </div>
      </div>
    </div>

    {/* Linha das perguntas Sim/Não */}
    <div style={{
      display: 'flex',
      gap: 50,
      justifyContent: 'flex-start',
      margin: '10px 0 0 3px',
      flexWrap: 'wrap'
    }}>
      
{/* Linha das perguntas Sim/Não */}
<div style={{
  display: 'flex',
  justifyContent: 'flex-start',
  margin: '10px 0 0 3px',
  flexWrap: 'wrap',
  gap: 50
}}>
  {/* Amostra física conferida */}
  <div style={{ minWidth: 250 }}>
    <span style={{ fontWeight: 500, fontSize: 15 }}>Amostra física conferida com a faca:</span>
    <div>
      <label style={{ marginRight: 12 }}>
        <input
          type="radio"
          disabled={somenteLeitura}
          name={`amostraConferida_${processo}`}
          checked={dados[processo]?.amostraConferida === 'sim'}
          onChange={() => handleChange(processo, 'amostraConferida', 'sim')}
        /> Sim
      </label>
      <label>
        <input
          type="radio"
          disabled={somenteLeitura}
          name={`amostraConferida_${processo}`}
          checked={dados[processo]?.amostraConferida === 'nao'}
          onChange={() => handleChange(processo, 'amostraConferida', 'nao')}
        /> Não
      </label>
    </div>
  </div>

  {/* Registro conferido */}
  <div style={{ minWidth: 250 }}>
    <span style={{ fontWeight: 500, fontSize: 15 }}>Registro conferido:</span>
    <div>
      <label style={{ marginRight: 12 }}>
        <input
          type="radio"
          disabled={somenteLeitura}
          name={`registroConferido_${processo}`}
          checked={dados[processo]?.registroConferido === 'sim'}
          onChange={() => handleChange(processo, 'registroConferido', 'sim')}
        /> Sim
      </label>
      <label>
        <input
          type="radio"
          disabled={somenteLeitura}
          name={`registroConferido_${processo}`}
          checked={dados[processo]?.registroConferido === 'nao'}
          onChange={() => handleChange(processo, 'registroConferido', 'nao')}
        /> Não
      </label>
    </div>
  </div>

  {/* Piques conferidos */}
  <div style={{ minWidth: 250 }}>
    <span style={{ fontWeight: 500, fontSize: 15 }}>Piques conferidos?</span>
    <div>
      <label style={{ marginRight: 12 }}>
        <input
          type="radio"
          disabled={somenteLeitura}
          name={`piquesConferidos_${processo}`}
          checked={dados[processo]?.piquesConferidos === 'sim'}
          onChange={() => handleChange(processo, 'piquesConferidos', 'sim')}
        /> Sim
      </label>
      <label>
        <input
          type="radio"
          disabled={somenteLeitura}
          name={`piquesConferidos_${processo}`}
          checked={dados[processo]?.piquesConferidos === 'nao'}
          onChange={() => handleChange(processo, 'piquesConferidos', 'nao')}
        /> Não
      </label>
    </div>
  </div>
</div>





    </div>
  </div>
)}



{/* Layout Especial Fechadora */}
{processo === "Fechadora" && (
  <div style={{
    background: '#fcfcf7',
    padding: 16,
    borderRadius: 8,
    marginBottom: 12,
    marginTop: 8
  }}>

    {/* Gestor do Processo */}
    <div style={{ marginBottom: 12 }}>
      <label style={{ fontWeight: 500, fontSize: 15 }}>
        Gestor do Processo:&nbsp;
        <input
          type="text"
          disabled={somenteLeitura}
          value={dados[processo]?.gestorProcesso || ''}
          onChange={e => handleChange(processo, 'gestorProcesso', e.target.value)}
          style={{ width: 280, fontSize: 15, padding: '4px 8px', borderRadius: 5, border: '1px solid #aaa' }}
        />
      </label>
    </div>

    {/* Máquinas da Fechadora */}
    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 18,
      marginBottom: 18,
      alignItems: 'center'
    }}>
      {[
        ['maquinaZh1000', 'ZH1000'],
        ['maquinaSts', 'STS'],
        ['maquinaSbl1', 'SBL 1'],
        ['maquinaSbl2', 'SBL 2'],
      ].map(([campo, label]) => (
        <label key={campo} style={{ display: 'flex', alignItems: 'center', fontSize: 14, minWidth: 130 }}>
          <input
            type="checkbox"
            disabled={somenteLeitura}
            checked={!!dados[processo]?.[campo]}
            onChange={e => handleChange(processo, campo, e.target.checked)}
            style={{ marginRight: 6 }}
          />
          {label}
        </label>
      ))}
    </div>

    <div style={{
      display: 'flex',
      flexWrap: 'nowrap',
      gap: 24,
      marginBottom: 10,
      justifyContent: 'space-between'
    }}>



      
      {/* Coluna 1: Dificuldade no acerto */}
      <div style={{ flex: 1, minWidth: 200 }}>
        <div style={{ fontWeight: 500, fontSize: 15, marginBottom: 4 }}>
          Problemas no acerto?
          <label style={{ marginLeft: 8 }}>
            <input
              type="checkbox"
              disabled={somenteLeitura}
              checked={!!dados[processo]?.dificuldadeAcertoSim}
              onChange={e => handleChange(processo, 'dificuldadeAcertoSim', e.target.checked)}
            /> Sim
          </label>
          <label style={{ marginLeft: 8 }}>
            <input
              type="checkbox"
              disabled={somenteLeitura}
              checked={!!dados[processo]?.dificuldadeAcertoNao}
              onChange={e => handleChange(processo, 'dificuldadeAcertoNao', e.target.checked)}
            /> Não
          </label>
        </div>
        <div style={{ marginBottom: 6, marginTop: 2 }}>
          Motivo?&nbsp;
          <input
            type="text"
            disabled={somenteLeitura}
            style={{ width: '100%' }}
            value={dados[processo]?.motivoDificuldadeAcerto || ''}
            onChange={e => handleChange(processo, 'motivoDificuldadeAcerto', e.target.value)}
          />
        </div>
        <div>
          <div style={{ marginBottom: 4 }}>Ações necessárias</div>
          <textarea
            disabled={somenteLeitura}
            style={{ width: '100%', height: 44, resize: 'vertical', fontSize: 14 }}
            value={dados[processo]?.acaoNecessariaDificuldade || ''}
            onChange={e => handleChange(processo, 'acaoNecessariaDificuldade', e.target.value)}
            placeholder="Descreva as ações..."
          />
        </div>
      </div>

      {/* Coluna 2: Caixa descolada */}
      <div style={{ flex: 1, minWidth: 200 }}>
        <div style={{ fontWeight: 500, fontSize: 15, marginBottom: 4 }}>
          Caixa descolada?
          <label style={{ marginLeft: 8 }}>
            <input
              type="checkbox"
              disabled={somenteLeitura}
              checked={!!dados[processo]?.caixaDescoladaSim}
              onChange={e => handleChange(processo, 'caixaDescoladaSim', e.target.checked)}
            /> Sim
          </label>
          <label style={{ marginLeft: 8 }}>
            <input
              type="checkbox"
              disabled={somenteLeitura}
              checked={!!dados[processo]?.caixaDescoladaNao}
              onChange={e => handleChange(processo, 'caixaDescoladaNao', e.target.checked)}
            /> Não
          </label>
        </div>
        <div style={{ marginBottom: 6, marginTop: 2 }}>
          Motivo?&nbsp;
          <input
            type="text"
            disabled={somenteLeitura}
            style={{ width: '100%' }}
            value={dados[processo]?.motivoCaixaDescolada || ''}
            onChange={e => handleChange(processo, 'motivoCaixaDescolada', e.target.value)}
          />
        </div>
        <div>
          <div style={{ marginBottom: 4 }}>Ações necessárias</div>
          <textarea
            disabled={somenteLeitura}
            style={{ width: '100%', height: 44, resize: 'vertical', fontSize: 14 }}
            value={dados[processo]?.acaoNecessariaCaixaDescolada || ''}
            onChange={e => handleChange(processo, 'acaoNecessariaCaixaDescolada', e.target.value)}
            placeholder="Descreva as ações..."
          />
        </div>
      </div>

      {/* Coluna 3: Outros + Velocidade Produção */}
      <div style={{ flex: 1, minWidth: 200 }}>
        <div style={{ fontWeight: 500, fontSize: 15, marginBottom: 4 }}>
          Outros:
        </div>
        <div style={{ marginBottom: 6, marginTop: 2 }}>
          Motivo?&nbsp;
          <input
            type="text"
            disabled={somenteLeitura}
            style={{ width: '100%' }}
            value={dados[processo]?.motivoOutros || ''}
            onChange={e => handleChange(processo, 'motivoOutros', e.target.value)}
          />
        </div>
        <div>
          <div style={{ marginBottom: 4 }}>Ações necessárias</div>
          <textarea
            disabled={somenteLeitura}
            style={{ width: '100%', height: 44, resize: 'vertical', fontSize: 14 }}
            value={dados[processo]?.acaoNecessariaOutros || ''}
            onChange={e => handleChange(processo, 'acaoNecessariaOutros', e.target.value)}
            placeholder="Descreva as ações..."
          />
        </div>
        <div style={{ marginTop: 12 }}>
          <div style={{ fontWeight: 500, fontSize: 15, marginBottom: 4 }}>Velocidade de Produção</div>
          <input
            type="text"
            disabled={somenteLeitura}
            style={{ width: '100%' }}
            value={dados[processo]?.velocidadeProducao || ''}
            onChange={e => handleChange(processo, 'velocidadeProducao', e.target.value)}
            placeholder="Ex: 15000 P/H"
          />
        </div>
      </div>
    </div>

    {/* Fundo automático revisado */}
    <div style={{ marginTop: 10 }}>
      <span style={{ fontWeight: 500, fontSize: 15 }}>
        Fundo automático revisado?
      </span>
      <label style={{ marginLeft: 8 }}>
        <input
          type="checkbox"
          disabled={somenteLeitura}
          checked={!!dados[processo]?.fundoAutomaticoRevisadoSim}
          onChange={e => handleChange(processo, 'fundoAutomaticoRevisadoSim', e.target.checked)}
        /> Sim
      </label>
      <label style={{ marginLeft: 8 }}>
        <input
          type="checkbox"
          disabled={somenteLeitura}
          checked={!!dados[processo]?.fundoAutomaticoRevisadoNao}
          onChange={e => handleChange(processo, 'fundoAutomaticoRevisadoNao', e.target.checked)}
        /> Não
      </label>
    </div>
  </div>
)}


{/* Padrão: layout em GRID para todos os outros processos */}
{!["Impressão", "Serigrafia", "Corte e Vinco", "Fechadora"].includes(processo) && (

  <div
    style={{
      background: '#fcfcf7',
      padding: 16,
      borderRadius: 8,
      marginTop: 8,
      marginBottom: 12,
      width: '100%',
      minWidth: 648,
      overflowX: 'auto',
      boxSizing: 'border-box',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
      gap: '20px 32px',
      alignItems: 'center'
    }}
  >



    {getCampos(processo).map(campo => (
      <div key={campo.nome} style={{ marginBottom: 8, display: 'flex', flexDirection: 'column' }}>
        <label style={{ fontWeight: 500, marginBottom: 3 }}>
          {campo.label}:
        </label>
{campo.tipo === 'select' ? (
  <select
    disabled={somenteLeitura}
    value={dados[processo]?.[campo.nome] || ''}
    onChange={e => handleChange(processo, campo.nome, e.target.value)}
    style={{ fontSize: 15, padding: '3px 8px', borderRadius: 6, border: '1px solid #bbb', minWidth: 110 }}
  >
    <option value="">Selecione</option>
    {campo.opcoes.map(op => (
      <option key={op} value={op}>{op}</option>
    ))}
  </select>
) : campo.tipo === 'textarea' ? (
  <textarea
    disabled={somenteLeitura}
    style={{ width: '100%', minWidth: 160, maxWidth: 320, minHeight: 38, fontSize: 15, resize: 'vertical' }}
    value={dados[processo]?.[campo.nome] || ''}
    onChange={e => handleChange(processo, campo.nome, e.target.value)}
  />
) : campo.tipo === 'checkbox' ? (
  <input
    type="checkbox"
    disabled={somenteLeitura}
    checked={!!dados[processo]?.[campo.nome]}
    onChange={e => handleChange(processo, campo.nome, e.target.checked)}
    style={{ width: 18, height: 18 }}
  />
) : campo.tipo === 'radio' ? (
  <div style={{ display: 'flex', gap: 12 }}>
    {campo.opcoes.map(opcao => (
      <label key={opcao} style={{ display: 'flex', alignItems: 'center', fontSize: 14 }}>
        <input
          type="radio"
          name={`${campo.nome}_${processo}`}
          disabled={somenteLeitura}
          checked={dados[processo]?.[campo.nome] === opcao}
          onChange={() => handleChange(processo, campo.nome, opcao)}
          style={{ marginRight: 4 }}
        />
        {opcao}
      </label>
    ))}
  </div>
) : (
  <input
    type={campo.tipo}
    disabled={somenteLeitura}
    placeholder={campo.placeholder || ''}
    style={{ width: '100%', minWidth: 130, maxWidth: 210, fontSize: 15, padding: '2px 8px', borderRadius: 5, border: '1px solid #bbb' }}
    value={dados[processo]?.[campo.nome] || ''}
    onChange={e => handleChange(processo, campo.nome, e.target.value)}
  />
)}

      </div>
    ))}
  </div>
)}

{/* Parecer do Setor */}
<textarea
  disabled={somenteLeitura}
  ref={(el) => {
    if (el) {
      el.style.height = 'auto';
      el.style.height = el.scrollHeight + 'px';
    }
  }}
  rows={1}
  style={{
    width: '100%',
    minWidth: 260,
    overflow: 'hidden',
    fontSize: 15,
    resize: 'none',
    marginTop: 2,
    lineHeight: 1.5,
    padding: 6,
    borderRadius: 6,
    border: '1px solid #aaa'
  }}
  value={dados[processo]?.parecer_setor || ''}
  onChange={e => {
    const el = e.target;
    el.style.height = 'auto';
    el.style.height = el.scrollHeight + 'px';
    handleParecerChange(processo, 'setor', el.value);
  }}
  placeholder="Digite o parecer do setor de Produção para este processo..."
/>




{/* Parecer dos Novos Projetos */}
<textarea
  disabled={somenteLeitura}
  ref={(el) => {
    if (el) {
      el.style.height = 'auto';
      el.style.height = el.scrollHeight + 'px';
    }
  }}
  rows={1}
  style={{
    width: '100%',
    minWidth: 260,
    overflow: 'hidden',
    fontSize: 15,
    resize: 'none',
    marginTop: 2,
    lineHeight: 1.5,
    padding: 6,
    borderRadius: 6,
    border: '1px solid #aaa'
  }}
  value={dados[processo]?.parecer_novos || ''}
  onChange={e => {
    const el = e.target;
    el.style.height = 'auto';
    el.style.height = el.scrollHeight + 'px';
    handleParecerChange(processo, 'novos', el.value);
  }}
  placeholder="Digite o parecer do setor de Novos Projetos para este processo..."
/>



{/* Botão para Ações Pós Produção */}
<button
  type="button"
  onClick={() => handleAbrirAcoes && handleAbrirAcoes(processo)}
  style={{
    backgroundColor: '#6a1b9a',
    color: '#fff',
    fontWeight: 'bold',
    padding: '12px',
    borderRadius: 8,
    width: '100%',
    marginTop: 20,
    fontSize: 16
  }}
>
  Ações Pós Produção
</button>








{/* Galeria de Imagens (3 colunas x 2 linhas) */}
{dados[processo]?.anexos && (
  <div style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '12px',
    margin: '20px 0',
    padding: '12px',
    background: '#f9f9f9',
    border: '1px solid #ddd',
    borderRadius: 8
  }}>
    {[1, 2, 3, 4, 5, 6].map(i => {
      const campo = `anexo${i}`;
      const anexo = dados[processo]?.anexos?.[campo];
      if (!anexo?.nome) return null;

      const url = `https://projetos.impram.com.br/Anexos/${normalizeNome(processo)}/${anexo.nome}`;



      
return (
  <div
    key={campo}
    onClick={() => {
      const isVideo = /\.(mp4|webm|ogg)$/i.test(anexo.nome);
      setImagemModalAberto({
        url,
        nome: `Anexo ${i}`,
        tipo: isVideo ? 'video' : 'imagem',
        processo,
        campo
      });
    }}
    style={{
      border: '1px solid #ccc',
      borderRadius: 6,
      padding: 6,
      background: '#fff',
      textAlign: 'center',
      cursor: 'pointer',
      transition: 'transform 0.2s',
    }}
  >
    <div style={{ fontSize: 14, marginBottom: 6 }}>Anexo {i}</div>

    {/\.(mp4|webm|ogg)$/i.test(anexo.nome) ? (
      <video
        src={url}
        muted
        preload="metadata"
        playsInline
        controls={false}
        style={{
          width: '100%',
          maxHeight: 140,
          borderRadius: 4,
          objectFit: 'cover',
          backgroundColor: '#000'
        }}
      />
    ) : (
      <img
        src={url}
        alt={`Anexo ${i}`}
        style={{
          width: '100%',
          maxHeight: 140,
          objectFit: 'cover',
          borderRadius: 4
        }}
      />
    )}
  </div>
);


    })}
  </div>
)}



{/* Aprovações em linha e assinaturas abaixo */}
<div style={{ marginTop: 10, marginBottom: 6 }}>
  {/* Linha de aprovação e botões */}
  <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap'
  }}>
    {/* Aprovação do Gestor */}
    <span style={{ fontWeight: 500, fontSize: 12 }}>
      Aprovação do Gestor:&nbsp;
    </span>
    <label style={{ marginRight: 8 }}>
      <input
        type="radio"
        name={`aprovGestor_${processo}`}
        disabled={somenteLeitura}
        checked={dados[processo]?.aprovGestor === 'sim'}
        onChange={() => handleChange(processo, 'aprovGestor', 'sim')}
      /> SIM
    </label>
    <label style={{ marginRight: 8 }}>
      <input
        type="radio"
        name={`aprovGestor_${processo}`}
        disabled={somenteLeitura}
        checked={dados[processo]?.aprovGestor === 'nao'}
        onChange={() => handleChange(processo, 'aprovGestor', 'nao')}
      /> NÃO
    </label>
    <button
      type="button"
      onClick={() => setModalAssinatura({ processo, campo: 'assinGestor' })}
      style={{
        padding: '4px 8px', fontSize: 12, cursor: 'pointer',
        background: '#eee', border: '1px solid #ccc', borderRadius: 4
      }}
    >
      {dados[processo]?.assinGestor ? 'Reassinar' : 'Assinar'}
    </button>

    {/* Aprovação Novos Projetos */}
    <span style={{ fontWeight: 500, fontSize: 12 }}>
      &nbsp;&nbsp;Aprovação Novos Projetos:&nbsp;
    </span>
    <label style={{ marginRight: 6 }}>
      <input
        type="radio"
        name={`aprovNovos_${processo}`}
        disabled={somenteLeitura}
        checked={dados[processo]?.aprovNovos === 'sim'}
        onChange={() => handleChange(processo, 'aprovNovos', 'sim')}
      /> SIM
    </label>
    <label style={{ marginRight: 6 }}>
      <input
        type="radio"
        name={`aprovNovos_${processo}`}
        disabled={somenteLeitura}
        checked={dados[processo]?.aprovNovos === 'nao'}
        onChange={() => handleChange(processo, 'aprovNovos', 'nao')}
      /> NÃO
    </label>
    <button
      type="button"
      onClick={() => setModalAssinatura({ processo, campo: 'assinNovos' })}
      style={{
        padding: '4px 8px', fontSize: 12, cursor: 'pointer',
        background: '#eee', border: '1px solid #ccc', borderRadius: 4
      }}
    >
      {dados[processo]?.assinNovos ? 'Reassinar' : 'Assinar'}
    </button>
  </div>

  {/* Linha abaixo com as duas assinaturas lado a lado */}
{(dados[processo]?.assinGestor || dados[processo]?.assinNovos) && (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 60,
    marginTop: 20,
    flexWrap: 'wrap'
  }}>

      
      
{dados[processo]?.assinGestor && (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, minWidth: 160 }}>

    <strong style={{ fontSize: 13 }}>Assinatura (Gestor):</strong>
    <img
      src={dados[processo].assinGestor}
      alt="Assinatura Gestor"
      style={{
        maxHeight: 48,
        border: '1px solid #999',
        background: '#fff',
        padding: 2,
        borderRadius: 4
      }}
      onClick={() => setModalAssinatura({ processo, campo: 'assinGestor' })}
    />
    <div style={{ fontSize: 12, color: '#555' }}>
      {dados[processo]?.assinadoPorGestor && `(${dados[processo].assinadoPorGestor})`}
    </div>
  </div>
)}


{dados[processo]?.assinNovos && (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, minWidth: 160 }}>

    <strong style={{ fontSize: 13 }}>Assinatura (Novos Projetos):</strong>
    <img
      src={dados[processo].assinNovos}
      alt="Assinatura Novos"
      style={{
        maxHeight: 48,
        border: '1px solid #999',
        background: '#fff',
        padding: 2,
        borderRadius: 4
      }}
      onClick={() => setModalAssinatura({ processo, campo: 'assinNovos' })}
    />
    <div style={{ fontSize: 12, color: '#555' }}>
      {dados[processo]?.assinadoPorNovos && `(${dados[processo].assinadoPorNovos})`}
    </div>
  </div>
)}




    </div>
  )}
</div>


        </motion.fieldset>
      ))}

      {/* Botões só aparecem se tiver pelo menos 1 processo */}
      {processos.length > 0 && !somenteLeitura && (
  <div style={{ marginTop: 20, textAlign: 'center' }}>
    <button
      type="button"
      onClick={handleSalvar}

        style={{
          marginRight: 20, padding: '12px 40px', fontWeight: 'bold', fontSize: 18,
          borderRadius: 30, border: 'none', background: '#2fbb59', color: '#fff',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', transition: 'background 0.3s'
        }}
      >
        Salvar
      </button>


      {feedback && (
        <motion.span
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          style={{ color: '#2fbb59', fontWeight: 'bold', marginLeft: 10, alignSelf: 'center' }}
        >
          {feedback}
        </motion.span>
      )}


    </div>
  )}



{imagemModalAberto && (
  <div
    onClick={() => setImagemModalAberto(null)}
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.85)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: 20
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        maxWidth: '90%',
        maxHeight: '90%',
        position: 'relative'
      }}
    >
      {/* Botão Fechar */}
      <button
        onClick={() => setImagemModalAberto(null)}
        style={{
          position: 'absolute',
          top: -14,
          right: -14,
          background: '#fff',
          color: '#000',
          borderRadius: '50%',
          border: 'none',
          width: 32,
          height: 32,
          fontWeight: 'bold',
          cursor: 'pointer',
          boxShadow: '0 0 6px rgba(0,0,0,0.3)'
        }}
      >
        ✕
      </button>

      {/* Botão Rotacionar (somente imagem) */}
      {imagemModalAberto.tipo !== 'video' && (
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setImagemModalAberto(prev => ({
              ...prev,
              rotacao: ((prev?.rotacao || 0) + 90) % 360
            }));
          }}
          style={{
            position: 'absolute',
            top: -14,
            left: -14,
            background: '#fff',
            color: '#000',
            borderRadius: '50%',
            border: 'none',
            width: 32,
            height: 32,
            fontWeight: 'bold',
            cursor: 'pointer',
            boxShadow: '0 0 6px rgba(0,0,0,0.3)'
          }}
        >
          🔄
        </button>
      )}





{/* Imagem ou Vídeo + Legenda que aparece ao passar o mouse */}
<div style={{ position: 'relative' }}>
  {imagemModalAberto.tipo === 'video' ? (
    <video
      src={imagemModalAberto.url}
      controls
      autoPlay
      style={{
        width: '100%',
        height: 'auto',
        maxHeight: '90vh',
        objectFit: 'contain',
        borderRadius: 8,
        background: '#000'
      }}
    />
  ) : (
    <img
      src={imagemModalAberto.url}
      alt={imagemModalAberto.nome}
      style={{
        width: '100%',
        height: 'auto',
        maxHeight: '90vh',
        objectFit: 'contain',
        borderRadius: 8,
        cursor: 'zoom-in',
        transition: 'transform 0.3s',
        transform: `rotate(${imagemModalAberto.rotacao || 0}deg) scale(${imagemModalAberto.zoom || 1})`
      }}
      onClick={(e) => {
        e.stopPropagation();
        setImagemModalAberto(prev => ({
          ...prev,
          zoom: (prev.zoom || 1) >= 3 ? 1 : (prev.zoom || 1) + 1
        }));
      }}
    />
  )}

  {/* Legenda ao passar o mouse */}
  {(() => {
    const processo = imagemModalAberto.processo;
    const campo = imagemModalAberto.campo;
    const legenda = dados?.[processo]?.anexos?.[campo]?.legenda;
    return legenda ? (
      <div
        onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
        onMouseLeave={(e) => (e.currentTarget.style.opacity = 0)}
        style={{
          position: 'absolute',
          bottom: 20,
          left: 0,
          right: 0,
          padding: '12px 24px',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          color: '#fff',
          fontSize: 20,
          fontStyle: 'italic',
          textAlign: 'center',
          zIndex: 2,
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word',
          opacity: 0,
          transition: 'opacity 0.3s ease',
          pointerEvents: 'auto',
          cursor: 'default'
        }}
      >
        📝 {legenda}
      </div>
    ) : null;
  })()}
</div>





    </div>
  </div>
)}








{modalAssinatura && (
  <div style={{
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.65)',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <div style={{
      background: '#fff',
      padding: 20,
      borderRadius: 8,
      maxWidth: 420,
      width: '90%',
      textAlign: 'center',
      boxShadow: '0 0 10px rgba(0,0,0,0.4)'
    }}>
      <h3>Assinatura - {modalAssinatura.campo === 'assinGestor' ? 'Gestor' : 'Novos Projetos'}</h3>
      <SignatureCanvas
        penColor="black"
        canvasProps={{ width: 380, height: 120, className: 'sigCanvas' }}
        ref={(ref) => setRefAssinatura(ref)}
        backgroundColor="#fff"
        style={{ border: '1px solid #ccc', borderRadius: 4 }}
      />

      <div style={{ marginTop: 12, display: 'flex', justifyContent: 'space-between' }}>
        <button onClick={() => refAssinatura.clear()} style={{ padding: '4px 10px' }}>Limpar</button>
        <button onClick={() => setModalAssinatura(null)} style={{ padding: '4px 10px' }}>Cancelar</button>
        
        
<button
  onClick={() => {
    if (!refAssinatura.isEmpty()) {
      const assinaturaURL = refAssinatura.getTrimmedCanvas().toDataURL('image/png');
      const campo = modalAssinatura.campo;

      const novoCampoNome = campo === 'assinGestor' ? 'assinadoPorGestor' : 'assinadoPorNovos';

      setDados(prev => ({
        ...prev,
        [modalAssinatura.processo]: {
          ...prev[modalAssinatura.processo],
          [campo]: assinaturaURL,
          [novoCampoNome]: usuario?.nome || 'Desconhecido'
        }
      }));

      setModalAssinatura(null);
    }
  }}
  style={{ padding: '4px 10px', background: '#2fbb59', color: '#fff', borderRadius: 4 }}
>
  Salvar
</button>




      </div>
    </div>
  </div>
)}





</form>

  );
};


export default ProcessoForm;
